import { render, staticRenderFns } from "./AiBookOrderData.vue?vue&type=template&id=1bcbfa3f&scoped=true"
import script from "./AiBookOrderData.vue?vue&type=script&lang=js"
export * from "./AiBookOrderData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcbfa3f",
  null
  
)

export default component.exports